export default function triggerWindowResize () {
  window.addEventListener('load', () => {
    window.dispatchEvent(new Event('resize')); // Trigger window resize when page has loaded to correct visual errors in case of JS/CSS race condition
  });
}
